import { APIURL } from "../../../config/api";

interface ILazyLoadingDropdownField {
  name: string;
  choicesURL: string;
  displayValuesURL: string;
  takeParameterName: string;
  choicesFilterParameterName: string;
  displayValuesFilterParameterName: string;
  categoryParameterName?: string;
  categoryFieldName?: string;
}

export const LazyLoadingDropdownFields = (
  elements: any[]
): ILazyLoadingDropdownField[] => {
  const result: ILazyLoadingDropdownField[] = [];

  //const rootElements = elements?.[0]?.elements || [];

  const traverseElements = (els: any[]) => {
    els.forEach((el) => {
      if (el.type === "dropdown" && el.lazyLoad) {
        result.push({
          name: el.name,
          choicesURL: el.choicesURL || `${APIURL}/dropdown/${el.name}`,
          displayValuesURL:
            el.displayValuesURL || `${APIURL}/dropdown/${el.name}/values`,
          takeParameterName: el.takeParameterName || "take",
          choicesFilterParameterName: el.choicesFilterParameterName || "filter",
          displayValuesFilterParameterName:
            el.displayValuesFilterParameterName || "id",
          categoryParameterName: el.categoryParameterName,
          categoryFieldName: el.categoryFieldName,
        });
      } else if (el.type === "panel" && Array.isArray(el.elements)) {
        traverseElements(el.elements); // Recurse into panel
      } else if (
        el.type === "paneldynamic" &&
        Array.isArray(el.templateElements)
      ) {
        traverseElements(el.templateElements); // Recurse into panelDynamic
      }
    });
  };

  elements.forEach((element) => {
    traverseElements(element.elements);
  });
  return result;
};
